
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { ProviderWizard } from '@/components/admin/provider-wizard/ProviderWizard';
import { Separator } from "@/components/ui/separator";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Create a client
const queryClient = new QueryClient();

const NewProvider = () => {
  return (
    <div className="container mx-auto py-8 px-4 max-w-6xl">
      <div className="mb-8">
        <div className="flex items-center gap-2 mb-2">
          <Link to="/admin">
            <Button variant="ghost" size="sm" className="h-8 gap-1">
              <ChevronLeft className="h-4 w-4" />
              Back to Admin
            </Button>
          </Link>
        </div>
        <h1 className="text-3xl font-bold tracking-tight">New Provider Integration</h1>
        <p className="text-muted-foreground mt-1">Create a new trading provider with all required configuration</p>
        <Separator className="mt-4" />
      </div>
      
      <QueryClientProvider client={queryClient}>
        <ProviderWizard />
      </QueryClientProvider>
    </div>
  );
};

export default NewProvider;
